import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerzekeringenPageHemaComponent } from './verzekeringen-page-hema.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: VerzekeringenPageHemaComponent,
        data: {
            title: 'Uw HEMA Schadeverzekeringen zijn over naar InShared – InShared',
            description:
                'Alle HEMA schadeverzekeringen voor op de weg, thuis en uw gezin vindt u vanaf nu bij InShared. Geen zorgen: u blijft top verzekerd tegen een scherpe prijs.',
            robots: 'index, follow',
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class VerzekeringenPageHemaRoutingModule {}
